import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Box from '@mui/joy/Box';
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import ProductList from './ProductList';
import CategoryList from '../categories/CategoryList';
import BrandList from '../brands/BrandList';
import AttributeList from '../attributes/AttributeList';
import AttributeSetList from '../attribute-sets/AttributeSetList';
import SupplierProductList from './SupplierProductList';

type TabId = 'products' | 'categories' | 'brands' | 'attributes' | 'attribute-sets' | 'suppliers';

const TABS: { id: TabId; label: string }[] = [
  { id: 'products', label: 'Productos' },
  { id: 'suppliers', label: 'Proveedores' },
  { id: 'categories', label: 'Categorías' },
  { id: 'brands', label: 'Marcas' },
  { id: 'attributes', label: 'Atributos' },
  { id: 'attribute-sets', label: 'Conjuntos de Atributos' },
];

const ProductsHub: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = (searchParams.get('tab') as TabId) || 'products';

  const handleTabChange = (_: React.SyntheticEvent | null, value: string | number | null) => {
    if (!value || value === 'products') {
      setSearchParams({});
    } else {
      setSearchParams({ tab: value as string });
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{ bgcolor: 'transparent' }}
      >
        <TabList
          disableUnderline
          sx={{
            mb: 2,
            gap: 0.5,
            borderBottom: '2px solid',
            borderColor: 'divider',
            flexWrap: 'wrap',
          }}
        >
          {TABS.map((tab) => (
            <Tab
              key={tab.id}
              value={tab.id}
              disableIndicator={false}
              sx={{
                fontWeight: 'md',
                fontSize: 'sm',
                pb: 1.5,
                px: 2,
                '&[aria-selected="true"]': {
                  color: 'primary.500',
                  fontWeight: 'lg',
                },
              }}
            >
              {tab.label}
            </Tab>
          ))}
        </TabList>

        <TabPanel value="products" sx={{ p: 0 }}>
          <ProductList />
        </TabPanel>
        <TabPanel value="suppliers" sx={{ p: 0 }}>
          <SupplierProductList />
        </TabPanel>
        <TabPanel value="categories" sx={{ p: 0 }}>
          <CategoryList />
        </TabPanel>
        <TabPanel value="brands" sx={{ p: 0 }}>
          <BrandList />
        </TabPanel>
        <TabPanel value="attributes" sx={{ p: 0 }}>
          <AttributeList />
        </TabPanel>
        <TabPanel value="attribute-sets" sx={{ p: 0 }}>
          <AttributeSetList />
        </TabPanel>
      </Tabs>
    </Box>
  );
};

export default ProductsHub;
